import { tail } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import {
    FIELD_LENGTH,
    InputEmail,
    InputPhoneNumber,
    InputText,
    ValidationService,
    TextArea,
} from '@sm360/widget-commons-forms';
import { AnalyticsService, ShiftDigitalService } from '@sm360/widget-commons-general';

class FormAskQuestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inputs: {
                phoneNumber: '',
                email: '',
                name: '',
                question: '',
            },
            formValidation: {
                name: false,
                question: false,
                email: false,
                phone: false,
            },
            sdSendLeadEvent: false,
            hasBeenSubmit: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVisitQuestion = this.handleVisitQuestion.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    handlePhoneNumberChange(phoneNumberResponse) {
        const { inputs, formValidation } = this.state;

        formValidation.phone = phoneNumberResponse.validation;
        inputs.phoneNumber = phoneNumberResponse.value;

        this.setState({
            inputs,
            formValidation,
        });
    }

    handleInputChange(value, name) {
        const { inputs, formValidation, sdSendLeadEvent } = this.state;

        inputs[name] = value;

        if (name === 'email') {
            formValidation.email = ValidationService.validateEmail(value);
        } else {
            formValidation[name] = ValidationService.validateIsNotEmpty(value);
        }
        if (!sdSendLeadEvent) {
            this.setState({ sdSendLeadEvent: true });
            this.props.handleSDLeadEvent();
        }

        this.setState({
            inputs,
            formValidation,
        });
    }

    handleVisitQuestion(e) {
        const { inputs } = this.state;

        inputs.question = e.target.value;

        this.setState({
            inputs,
        });
    }

    submitForm() {
        if (!ValidationService.validateForm(this.state.formValidation)) {
            this.setState({
                hasBeenSubmit: true,
            });
            return;
        }

        const nameFields = this.state.inputs.name.split(' ');

        this.props.onSubmit({
            ...this.state.inputs,
            firstname: nameFields[0],
            lastname: tail(nameFields).join(' '),
        });

        AnalyticsService.eventDataLayer('form|vdp-question', 'submit', 'vdp-question-showroom');
        ShiftDigitalService.updateDrInitialClick(this.props?.quote?.id, this.props?.quote?.vehicle);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <p className="sr-title-2 is-centered is-alternate">{LocaleService.t('FORM_QUESTION.FORM_TITLE')}</p>
                <p className="visit-step">{LocaleService.t('FORM_QUESTION.FORM_SUBTITLE')}</p>

                <TextArea
                    label={LocaleService.t('FORM_QUESTION.MORE_INFO')}
                    errorLabel={LocaleService.t('FORM_QUESTION.ERRORS.QUESTION')}
                    name="question"
                    value={this.state.inputs.question}
                    onChange={this.handleVisitQuestion}
                    classNames={['styled-placeholder']}
                    isValid={this.state.formValidation.question}
                    isRequired
                    valueChange={this.handleInputChange}
                    hasBeenSubmit={this.state.hasBeenSubmit}
                    dataTest="vdp-used.form-ask-question.question"
                />

                <InputText
                    label={LocaleService.t('FORM_QUESTION.NAME')}
                    errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.NAME')}
                    name="name"
                    type="text"
                    value={this.state.inputs.name}
                    classNames={['styled-placeholder']}
                    isValid={this.state.formValidation.name}
                    isRequired
                    valueChange={this.handleInputChange}
                    hasBeenSubmit={this.state.hasBeenSubmit}
                    dataTest="vdp-used.form-ask-question.name"
                    maxLength={FIELD_LENGTH.FULL_NAME_MAX}
                />

                <InputEmail
                    label={LocaleService.t('FORM_QUESTION.EMAIL')}
                    errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.EMAIL')}
                    value={this.state.inputs.email}
                    classNames={['styled-placeholder']}
                    isRequired
                    isValid={this.state.formValidation.email}
                    valueChange={this.handleInputChange}
                    hasBeenSubmit={this.state.hasBeenSubmit}
                    dataTest="vdp-used.form-ask-question.email"
                />

                <InputPhoneNumber
                    label={LocaleService.t('FORM_QUESTION.PHONE_NUMBER')}
                    errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.PHONE_NUMBER')}
                    name="phoneNumber"
                    type="tel"
                    value={this.state.inputs.phoneNumber}
                    valueChange={this.handlePhoneNumberChange}
                    classNames={['styled-placeholder']}
                    isRequired
                    isValid={this.state.formValidation.phone}
                    hasBeenSubmit={this.state.hasBeenSubmit}
                    dataTest="vdp-used.form-ask-question.phone"
                />

                <button
                    className="cta-visit sr-button-1"
                    type="submit"
                    onClick={this.submitForm}
                    title={LocaleService.t('FORM_QUESTION.SEND_BUTTON')}
                    data-test="vdp-used.form-ask-question.submit-button"
                >
                    {LocaleService.t('FORM_QUESTION.SEND_BUTTON')}
                </button>
            </form>
        );
    }
}

FormAskQuestion.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSDLeadEvent: PropTypes.func,
};

FormAskQuestion.displayName = 'FormAskQuestion';

export default FormAskQuestion;
